export const BCBSAL_ORG_ID = '938125692074';
